import { render, staticRenderFns } from "./Combos.vue?vue&type=template&id=f46dacf8&scoped=true"
import script from "./Combos.vue?vue&type=script&lang=js"
export * from "./Combos.vue?vue&type=script&lang=js"
import style0 from "./Combos.vue?vue&type=style&index=0&id=f46dacf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46dacf8",
  null
  
)

export default component.exports